import PropTypes from 'prop-types';
import {AppRowContainer} from '@crema';
import {Col, Image, Tag, Divider} from 'antd';
import {Link} from 'react-router-dom';
import moment from 'moment';
import {DateFormat} from 'shared/constants/AppEnums';

function ViewBlog({data}) {
  console.log('data', data);
  return (
    <AppRowContainer>
      {/* Title */}
      <Col xs={8}>
        <p className='text-secondary'>Title</p>
      </Col>
      <Col xs={16}>
        <p style={{fontWeight: 'bold', fontSize: '16px'}}>
          {data.title ? data.title : 'N/A'}
        </p>
      </Col>

      {/* Short Description */}
      <Col xs={8}>
        <p className='text-secondary'>Short Description</p>
      </Col>
      <Col xs={16}>
        <p>{data.shortDescription ? data.shortDescription : 'N/A'}</p>
      </Col>

      {/* Content */}
      <Col xs={8}>
        <p className='text-secondary'>Content</p>
      </Col>
      <Col xs={16}>
        <div
          style={{
            border: '1px solid #d9d9d9',
            borderRadius: '6px',
            padding: '12px',
            backgroundColor: '#fafafa',
            minHeight: '100px',
          }}
          dangerouslySetInnerHTML={{
            __html: data.content || 'No content available',
          }}
        />
      </Col>

      {/* Author */}
      <Col xs={8}>
        <p className='text-secondary'>Author</p>
      </Col>
      <Col xs={16}>
        <p>{data.author ? data.author : 'N/A'}</p>
      </Col>

      {/* Published On */}
      <Col xs={8}>
        <p className='text-secondary'>Published On</p>
      </Col>
      <Col xs={16}>
        <p>
          {data.publishedOn
            ? moment(data.publishedOn).format(DateFormat.ONLY_DATE_WITH_SLASH)
            : 'Not published'}
        </p>
      </Col>

      {/* Banner Image */}
      <Col xs={8}>
        <p className='text-secondary'>Banner Image</p>
      </Col>
      <Col xs={16}>
        {data.bannerImageUrl ? (
          <Image
            src={data.bannerImageUrl}
            width={200}
            style={{borderRadius: '6px'}}
            alt='Banner Image'
          />
        ) : (
          <p>No banner image</p>
        )}
      </Col>

      {/* Status */}
      <Col xs={8}>
        <p className='text-secondary'>Status</p>
      </Col>
      <Col xs={16}>
        <Tag color={data.isActive ? 'green' : 'red'}>
          {data.isActive ? 'Active' : 'Inactive'}
        </Tag>
      </Col>

      {/* Order */}
      <Col xs={8}>
        <p className='text-secondary'>Order</p>
      </Col>
      <Col xs={16}>
        <p>{data.order ? data.order : 'N/A'}</p>
      </Col>

      <Divider />

      {/* Created At */}
      <Col xs={8}>
        <p className='text-secondary'>Created At</p>
      </Col>
      <Col xs={16}>
        <p>
          {data.createdAt
            ? moment(data.createdAt).format(DateFormat.ONLY_DATE_WITH_SLASH)
            : 'N/A'}
        </p>
      </Col>

      {/* Updated At */}
      <Col xs={8}>
        <p className='text-secondary'>Updated At</p>
      </Col>
      <Col xs={16}>
        <p>
          {data.updatedAt
            ? moment(data.updatedAt).format(DateFormat.ONLY_DATE_WITH_SLASH)
            : 'N/A'}
        </p>
      </Col>
    </AppRowContainer>
  );
}

export default ViewBlog;
ViewBlog.propTypes = {
  user: PropTypes.object,
};
